import React from 'react'

import i18n from 'live/services/i18n'

import cx from 'classnames'
import { DropdownButton, MenuItem } from 'react-bootstrap'

import { StyledMenuItensList } from './sortOptionsStyles'
import { ReportsApprovalColumns, SortOption, handleChangeSorter } from '../../Table/helper/helper'

interface SortOptionsProps {
    selectedSorter: SortOption
    setSelectedSorter: (newSorter: SortOption) => void
}

export function SortOptions({ selectedSorter, setSelectedSorter }: SortOptionsProps) {
    function setClass(columnName: string) {
        return cx({
            active: selectedSorter.field === columnName,
            'dropdown-menu-item-arrow': true
        })
    }

    return (
        <StyledMenuItensList>
            <DropdownButton
                id="sort-dropdown-toggle"
                pullRight
                title={
                    <span>
                        <i className="fa fa-sort-alt no-margin" />
                    </span>
                }
                className="link no-caret sort-dropdown-toggle"
                bsStyle="default"
            >
                {Object.entries(ReportsApprovalColumns).map(([columnIndex, columnName]) =>
                    columnIndex ? (
                        <MenuItem
                            className={setClass(columnName)}
                            key={columnIndex}
                            onSelect={() => handleChangeSorter(columnName, selectedSorter, setSelectedSorter)}
                        >
                            {i18n(columnName)}
                        </MenuItem>
                    ) : null
                )}
            </DropdownButton>
        </StyledMenuItensList>
    )
}
